import React, { useState } from 'react';
import client from '../api/client';
import '../SeedingPage.css';
import '../ContractSeedingPage.css';

export const TITLE_MATCH_HINT =
  'Contract counts match outstanding contracts whose title is exactly this fitting name.';

/**
 * Rename a fitting, optionally re-pasting its EFT text. The fitting row is
 * updated in place, so its entries and target stock at every destination survive.
 */
function FittingEditModal({ fitting, onClose, onSaved }) {
  const [name, setName] = useState(fitting.name);
  const [eftText, setEftText] = useState(fitting.raw_fitting || '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const eftChanged = eftText.trim() !== (fitting.raw_fitting || '').trim();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      setError('Name cannot be empty');
      return;
    }
    setSaving(true);
    setError('');
    try {
      const body = eftChanged ? { name, raw_fitting: eftText } : { name };
      const response = await client.patch(`/contracts/fittings/${fitting.id}/update/`, body);
      onSaved(response.data);
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to update fitting');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal fitting-modal">
        <div className="modal-header">
          <h3>Edit Fitting</h3>
          <button onClick={onClose} className="icon-btn modal-close">×</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Name:</label>
            <input
              type="text"
              value={name}
              onChange={e => setName(e.target.value)}
              disabled={saving}
              autoFocus
            />
            <small className="form-hint">
              {TITLE_MATCH_HINT} Set it to the title you use in game.
            </small>
          </div>
          <details className="form-group">
            <summary>Edit EFT</summary>
            <textarea
              value={eftText}
              onChange={e => setEftText(e.target.value)}
              rows={16}
              className="eft-textarea"
              disabled={saving}
            />
            <small className="form-hint">
              The name above replaces the name in the EFT header line.
            </small>
          </details>
          {error && <div className="error-message">{error}</div>}
          <div className="modal-actions">
            <button type="button" onClick={onClose} disabled={saving} className="btn btn-ghost">Cancel</button>
            <button type="submit" disabled={saving || !name.trim()} className="btn btn-primary">
              {saving ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default FittingEditModal;
